export const getNewId = (type: string = "id") => {
  return `${type}_${Math.random().toString(36).slice(2)}${Date.now()}`;
};
